import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SettingsService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class SvodFlagGuard implements CanActivate {
  constructor(private settingsService: SettingsService, private router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(this.settingsService.isSvodEnabled) return true;
    else this.router.navigateByUrl('/home');
  }
  
}
